var _defs, _g, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _text19, _text20, _text21, _text22, _text23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 327.34 270.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#129d80;}.cls-4{font-size:14.01px;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{fill:#010101;font-family:Montserrat-SemiBold, Montserrat SemiBold;font-weight:600;}.cls-5{font-size:14.01px;}.cls-6{font-size:14.01px;}.cls-7{font-size:14.01px;}.cls-8{font-size:14.01px;}.cls-9{font-size:14.01px;}.cls-10{font-size:14.01px;}.cls-11{font-size:14.01px;}.cls-12{font-size:14.01px;}.cls-13{font-size:14.01px;}.cls-14{font-size:14.01px;}.cls-15{font-size:14.01px;}.cls-16{font-size:14.01px;}.cls-17{font-size:14.01px;}.cls-18{font-size:14.01px;}.cls-19{font-size:14.01px;}.cls-20{font-size:14.01px;}.cls-21{font-size:14.01px;}.cls-22{font-size:14.01px;}.cls-23{font-size:14.01px;}.cls-24{font-size:14.01px;}.cls-25{font-size:14.01px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-148 -302.89)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 595.28,
    height: 841.89
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M427.28,366.25c-.58-.29-.9.38-1.19.95-4.89,9.58-13.25,16.74-22.25,22.39s-19.14,9.4-29.5,12.53c-5.18,1.58-10.45,3-15.75,4.52S348,409.73,342.7,411.4c-3.06,1-6.14,2.05-9.21,3.26q2-2.09,4.1-4.14c12.14-11.87,26.07-23,35.86-37.92a52,52,0,0,0,6-11.92,59.28,59.28,0,0,0,2.84-12.95,61.85,61.85,0,0,0-2.7-26,.5.5,0,0,0-.62-.33.51.51,0,0,0-.36.62,60,60,0,0,1,1.18,25.32,56.57,56.57,0,0,1-3.4,12.13,48.89,48.89,0,0,1-6.27,10.79C360,383.92,346,393.92,332.84,405.37a131.14,131.14,0,0,0-18.51,19.14,108.36,108.36,0,0,0-13.8,23.22A102.78,102.78,0,0,0,293.16,474c0,.26,0,.52-.07.78-2.56-3.88-17-30.25-20.49-40.25-1.25-3.62-2.34-7.31-3.34-11a70.45,70.45,0,0,1,17.83-58c7.72-8.43,17.29-15.66,24.67-25.22a49.63,49.63,0,0,0,8.22-16,29.17,29.17,0,0,0-.14-17.78.55.55,0,0,0-.67-.34.54.54,0,0,0-.37.67,27.66,27.66,0,0,1-.81,16.83,47.06,47.06,0,0,1-8.64,14.67c-7.49,8.7-17.25,15.24-25.89,23.61A75.31,75.31,0,0,0,264.2,392.7c-.05.15-.09.31-.14.46a169.41,169.41,0,0,1-.34-21.38A166.42,166.42,0,0,1,268.49,340c2.65-10.34,6.67-20.62,13.93-28.69a.4.4,0,0,0,0-.57.45.45,0,0,0-.61,0c-8,7.66-12.95,18-16.45,28.37a172.31,172.31,0,0,0-7.26,32.23,174.19,174.19,0,0,0,4.28,65.46c-1.27-1.16-2.54-2.3-3.83-3.42-8.28-7.22-16.81-13.78-24.66-21S218.83,397.27,213.76,388s-8.1-19.86-6.88-30.55a.49.49,0,0,0-1-.15c-2.08,10.83.22,22.19,4.8,32.22s11.58,19,19.07,27,14.77,16.25,23.11,22.86c13.52,10.72,32.23,49.43,37.24,58.79,1.25,2.34,2.47,4.68,3.61,7s2.17,4.5,3.13,6.89a121.19,121.19,0,0,1,4.88,14.43,94.6,94.6,0,0,1,2.82,14.83h0c2.71.17,5.42.24,8.18.24,3.45,0,6.86-.11,10.23-.35h0a108.36,108.36,0,0,0-4.66-19.73,139.29,139.29,0,0,0-7.71-18.55,46,46,0,0,1-2.4-5.37,63.09,63.09,0,0,1-3.58-23.15c.26-7.69,2.64-15.69,5.23-22.92l.36-1a47.12,47.12,0,0,1,22.31-24.76c4.49-2.28,9-4,13.26-5.71,10.08-4.06,20.35-7.51,30.76-11.41s20.75-8.54,29.87-15.23,16.31-14.92,20.73-25.3c.23-.56.67-1.56.12-1.84",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M329.37,349.25c-4.18,5.07-9.14,11.93-11.75,18.39a20.18,20.18,0,0,0,15.63-15.78,54.34,54.34,0,0,0,.42-8.49A32.49,32.49,0,0,0,322,349.83a21.29,21.29,0,0,0-6.66,16.81,105.62,105.62,0,0,1,14-17.39",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M419.9,363.55c-6,2.69-13.48,6.65-18.67,11.29a20.16,20.16,0,0,0,21-7.23,54.16,54.16,0,0,0,4.14-7.43,32.64,32.64,0,0,0-13.32.63,21.33,21.33,0,0,0-13.41,12.12,107.25,107.25,0,0,1,20.27-9.38",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M375.2,337.47c-2.18,3.8-4.67,8.86-5.65,13.4A13.42,13.42,0,0,0,378,338.75a36.31,36.31,0,0,0-.67-5.63,21.87,21.87,0,0,0-6.94,5.56,14.21,14.21,0,0,0-2.49,11.79,71.5,71.5,0,0,1,7.26-13",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M356.33,338.7c-.3,5.46-.15,10.76,1.35,15.78a18.47,18.47,0,0,0-.92-22.32,17.19,17.19,0,0,0-.88,22.41,53.94,53.94,0,0,1,.45-15.87",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M349.62,355.74a18.62,18.62,0,0,0-15.62,7,22,22,0,0,0-4,9.32,18.38,18.38,0,0,0,8.77-2.78c4.83-3.05,8.19-8.07,10.88-13.52",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M404,383a17,17,0,0,0-15.17,3.73,20,20,0,0,0-5.15,7.72A16.89,16.89,0,0,0,392,393.4c4.84-2,8.68-5.92,12-10.38",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M328.48,332.41a32.72,32.72,0,0,0-1.06-7.42c-4.46,6.58-8.9,10.2-6,22.59,4.88-3.18,7.1-9.35,7-15.17",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M346.24,324.26a13.77,13.77,0,0,0-4.95,5.43c-1.86,3.87-1.57,8.28-.05,12.3a11.89,11.89,0,0,0,6.62-11.91,18.48,18.48,0,0,0-1.62-5.82",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M392.77,325a13.69,13.69,0,0,0-3.3,6.56c-.75,4.23.7,8.4,3.25,11.87a11.93,11.93,0,0,0,3.18-13.26,18.52,18.52,0,0,0-3.13-5.17",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M355.58,313.88a12.11,12.11,0,0,0-3.39,5.48A13.67,13.67,0,0,0,354.12,330a10.42,10.42,0,0,0,3.79-11.33,16.07,16.07,0,0,0-2.33-4.76",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389.74,354.56c-1.64,5.84-3.7,11.32-7.14,16a18.5,18.5,0,0,1,2.14-14.71,20.85,20.85,0,0,1,6.8-6.44,19.3,19.3,0,0,1,1.26,9.82,17.47,17.47,0,0,1-8.23,11.94,58.22,58.22,0,0,0,5.17-16.61",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M333.9,309.05c1,5.43,1.48,10.74.53,15.94a16.86,16.86,0,0,1-4.11-12.9,19.08,19.08,0,0,1,3-8,17.4,17.4,0,0,1,4.95,7.53,15.92,15.92,0,0,1-2,13.06,53.06,53.06,0,0,0-2.39-15.66",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M365.06,365.4a23.47,23.47,0,0,0,4.85-4.95,17.35,17.35,0,0,0-16.68,7.39c4,1.28,8.45,0,11.83-2.44",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M405.8,347.18a23.69,23.69,0,0,0-.18-6.93,17.39,17.39,0,0,0-6.33,17.12c3.7-2,5.92-6.05,6.51-10.19",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M372.22,323.58a20.07,20.07,0,0,0-.16-6,15,15,0,0,0-5.47,14.81c3.2-1.69,5.12-5.23,5.63-8.82",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M283.94,424.38c1.53,7.57,4.12,17.19,8.09,24.35a23.68,23.68,0,0,0-2.83-26,64.43,64.43,0,0,0-7.45-6.69c-1.77,4.76-3.1,10.4-2.74,15.45a25.1,25.1,0,0,0,10.42,18.54,125.2,125.2,0,0,1-5.49-25.69",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M319.93,375.39c-.46,4.74-.66,10.87.39,15.81a14.61,14.61,0,0,0,3-15.81,38.6,38.6,0,0,0-3.19-5.28,23.69,23.69,0,0,0-4.39,8.61,15.44,15.44,0,0,0,2.81,12.8,76.93,76.93,0,0,1,1.38-16.13",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M315.51,405.13c-2.39,5.31-4.28,10.61-4.72,16.16a20.14,20.14,0,0,0,8.31-12.6,19.92,19.92,0,0,0-.65-9.87A18.29,18.29,0,0,0,309,420.69a57.38,57.38,0,0,1,6.55-15.56",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M301.14,412.06a18.56,18.56,0,0,0-4,16.62,21.93,21.93,0,0,0,4.92,8.89,18.43,18.43,0,0,0,3.15-8.65c.53-5.69-1.4-11.42-4.08-16.86",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M353.5,375.76a17,17,0,0,0-13.48,7.9,20.1,20.1,0,0,0-2.73,8.86,16.82,16.82,0,0,0,7.69-3.4c4.07-3.25,6.63-8.15,8.52-13.36",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M284.33,395.65a38.68,38.68,0,0,0-5.94-6.52c0,9.36-1.91,15.83,9.14,25.94,2.64-6.32.72-13.81-3.2-19.42",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M304.54,383.12a13.75,13.75,0,0,0-3.38,6.53c-.79,4.22.62,8.4,3.13,11.89a11.89,11.89,0,0,0,3.32-13.21,18.76,18.76,0,0,0-3.07-5.21",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M303.48,356.9a15.63,15.63,0,0,0-2.54,8c-.08,4.89,2.31,9.32,5.79,12.76a13.56,13.56,0,0,0,1.19-15.47,21.09,21.09,0,0,0-4.44-5.25",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M372.51,388.7c-4.23,4.33-8.66,8.16-13.92,10.63a18.52,18.52,0,0,1,8.91-11.9,21.1,21.1,0,0,1,9.06-2.4,19.3,19.3,0,0,1-3.59,9.23A17.44,17.44,0,0,1,360,400.81a58.42,58.42,0,0,0,12.48-12.11",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M290.5,378.65c.71,5.47.94,10.8-.26,16a16.86,16.86,0,0,1-3.47-13.09,19,19,0,0,1,3.39-7.82,17.63,17.63,0,0,1,4.57,7.77,15.91,15.91,0,0,1-2.62,12.94,53.12,53.12,0,0,0-1.61-15.75",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M329.58,393.55a23.06,23.06,0,0,0-1.24-6.82,17.41,17.41,0,0,0-3.62,17.89c3.36-2.51,4.92-6.89,4.86-11.07",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M387.46,375.42a15.28,15.28,0,0,0-3.85,9,13.49,13.49,0,0,0,6.87-7.3,13.33,13.33,0,0,0,.87-4.84,15.22,15.22,0,0,0-3.89,3.12",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M330.84,456.52c-5.5,5.43-12.12,12.88-16.28,19.88,9-.71,18.22-6.55,20.76-15.84a50.06,50.06,0,0,0,1.19-10.51c-5.17.86-10.69,2.81-14.66,6-5.83,4.62-9.1,11.8-9.72,19,5-5.89,12.59-13.8,18.71-18.45",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389.59,509.64c-4.83-.17-11,.37-15.7,2.21,4.71,4.08,11.42,5.57,16.31,2.21a29.8,29.8,0,0,0,4.71-4.63c-2.88-2.37-6.38-4.33-9.59-4.77-4.7-.66-9.06,1.51-12.08,5.18a52.69,52.69,0,0,1,16.35-.2",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M343.77,499.28a59.8,59.8,0,0,0-18.71,7.88,28.35,28.35,0,0,0,18-1.68,21,21,0,0,0,8.9-8.06,19.63,19.63,0,0,0-14.25-1.79,24.9,24.9,0,0,0-13.41,9.62,62.07,62.07,0,0,1,19.45-6",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M341.16,482a17,17,0,0,0-17.11-1,24.12,24.12,0,0,0-7.7,6.62,20.2,20.2,0,0,0,8.81,1.05c5.6-.56,11-3.22,16-6.71",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M370.56,525.32c-3.52-6.12-8.94-9-14.29-8.69a19.39,19.39,0,0,0-8.79,3.06,20.73,20.73,0,0,0,7.18,4.92c4.95,2,10.46,1.88,15.9.71",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M354.62,453.48a33.79,33.79,0,0,0,1.94-9.38c-4.1,2.3-7.84,3.8-10.78,6.74s-5.06,7.29-6.5,15c7-.44,12.77-5.58,15.34-12.35",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M363.83,480.27a13.26,13.26,0,0,0-7.59-2.2c-4.4.23-7.89,3-10.48,6.45,4.69,3.18,10.14,3,13.93.32a15.59,15.59,0,0,0,4.14-4.57",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M387.15,474.56a12,12,0,0,0-8.48,1.14c-4.22,2.48-6.47,7.43-7.62,12.88,6.33,2.1,11.85-.58,14.32-6a22.81,22.81,0,0,0,1.78-8",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M347.92,428.7a9.94,9.94,0,0,0-7,.95c-3.5,2.06-5.37,6.17-6.32,10.69,5.25,1.74,9.83-.49,11.87-5a18.66,18.66,0,0,0,1.49-6.66",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M345.19,530.41a50.07,50.07,0,0,1-17.35-2.32,22.6,22.6,0,0,1,14.53-1.89,19.37,19.37,0,0,1,8.29,4.36,16.67,16.67,0,0,1-9,3.89c-4.86.4-9.59-1.52-13.74-4.66a52,52,0,0,0,17.31.62",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M367.57,459.54c-3.64,4.27-7.64,7.83-12.51,9.94.95-5.27,3.43-9.52,7.44-11.79a15.36,15.36,0,0,1,8.59-1.73,17.08,17.08,0,0,1-2.51,9.69c-2.6,3.84-6.94,5.56-12.06,5.48a40.29,40.29,0,0,0,11.05-11.59",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M367.69,502.85a21,21,0,0,0,3.47-6.66,14.66,14.66,0,0,0-7.84,2.55,19.39,19.39,0,0,0-6.83,8.69,12,12,0,0,0,11.2-4.58",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M393.84,433.24A163.92,163.92,0,0,0,371.71,446a30.66,30.66,0,0,0,13.49-.32,20.35,20.35,0,0,0,11.47-7.37,40.4,40.4,0,0,0,4.61-9.44,29.17,29.17,0,0,0-15.68,1.59,34.6,34.6,0,0,0-15.55,13.81c6.79-3.59,16.51-8.57,23.79-11.07",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M372.61,420.69c-2.18,4.27-5.42,9.49-9.13,12.92-1.39-5.9.89-12.28,5.94-15.15a34.44,34.44,0,0,1,5.91-2.33,22.87,22.87,0,0,1-.65,10.13,14,14,0,0,1-9.77,8.76,65.09,65.09,0,0,0,7.7-14.33",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M409.62,469.55a56.74,56.74,0,0,0-17.68,5.36c5.07,1.7,11.17,2.18,16.49.19a19.7,19.7,0,0,0,8.8-6.48A16.49,16.49,0,0,0,404.59,466a27.8,27.8,0,0,0-13.09,7.26,56.38,56.38,0,0,1,18.12-3.72",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M404.36,456a16,16,0,0,0-16.18-2.75,30.19,30.19,0,0,0-8.68,5.22c2.45,1,13.08,6.71,24.86-2.47",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M442.83,403.88c-6.4-.51-11.84,1.74-15.11,6a18.76,18.76,0,0,0-3.4,8.66,18.26,18.26,0,0,0,8.42-2.42c4.58-2.7,7.7-7.26,10.09-12.27",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M419.48,430.61a30.79,30.79,0,0,0,.28-9.81c-3.71,2.88-7.21,5-9.6,8.36s-3.71,8.08-4.18,15.78c6.78-1.42,12-7.12,13.5-14.33",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M433.44,453.61a15,15,0,0,0-3.86-2.28,10.18,10.18,0,0,0-3.85-.73c-4.49.17-7.76,3.18-10.52,6.39a17.06,17.06,0,0,0,6.94,2.3,11.73,11.73,0,0,0,6.79-1.43,15,15,0,0,0,4.5-4.25",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M413,402.84a11.8,11.8,0,0,0-8.59.16c-4.39,2.16-7.15,6.94-8.88,12.07a11.62,11.62,0,0,0,14.85-4.5,20.34,20.34,0,0,0,2.62-7.73",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M408.48,486.63c-5.36,2.88-10.78,5.11-16.55,5.78a18.88,18.88,0,0,1,12.13-8.68,19.59,19.59,0,0,1,9.39.62,18.54,18.54,0,0,1-6.25,7.95c-4,2.8-9.15,3.39-14.37,2a53.67,53.67,0,0,0,15.65-7.66",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M439.54,434.29c-5.24,3.37-10.65,5.56-16.43,5.93,2.86-5.23,6.77-9,11.71-10a15.3,15.3,0,0,1,9.57,1.45c-1.21,4.43-3.29,8-5.93,10.08-4,3.2-9.24,3-14.43.75a37.71,37.71,0,0,0,15.51-8.25",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M428,475.25a21.92,21.92,0,0,0,4-6.09,15.41,15.41,0,0,0-8,1.89,18.09,18.09,0,0,0-7.47,8.06c4.12,1,8.45-.78,11.45-3.86",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M433.07,383.21a21.91,21.91,0,0,0,.36-7.3,15.38,15.38,0,0,0-5.93,5.72,18.12,18.12,0,0,0-2.32,10.74c4.05-1.25,6.88-5,7.89-9.16",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M281,533.2a93,93,0,0,0,15.72-9c-6-1.27-13.59.23-17.64,5.5a32.06,32.06,0,0,0-3.42,6.37,24.11,24.11,0,0,0,11.09-.77,21,21,0,0,0,11.17-9.79A114.26,114.26,0,0,1,281,533.2",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M232.59,468.52c4.29,2.12,10,4.35,15,4.92a14.17,14.17,0,0,0-13.84-8.38,33.37,33.37,0,0,0-6.09,1.43,23.51,23.51,0,0,0,6.57,7.69,14.26,14.26,0,0,0,13.07,1.17,65.15,65.15,0,0,1-14.74-6.83",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M263.66,499.2a69.64,69.64,0,0,0,20.28.63,35.69,35.69,0,0,0-17-5.3,21.16,21.16,0,0,0-11.49,3,18.76,18.76,0,0,0,12.2,6.8c5.59.76,11.42-.7,16.2-2.88a66.61,66.61,0,0,1-20.16-2.26",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M264.68,520.61A16.42,16.42,0,0,0,281,518.28a29,29,0,0,0,6.73-7.58,21,21,0,0,0-8.29.91c-5.2,1.6-10.26,4.94-14.76,9",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M245,456.73c1.67,5.32,5.23,9.9,10.28,11.82a19.41,19.41,0,0,0,9.23,1,16.69,16.69,0,0,0-4.72-7.18c-4-3.47-9.31-4.87-14.79-5.66",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M239.68,434.28a32.38,32.38,0,0,0-9.23-1.9c2.41,4,4.05,7.7,7,10.59s7.32,4.95,14.72,6.51c-.76-6.83-5.82-12.63-12.53-15.2",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M226.3,509.66a14.31,14.31,0,0,0,8.36-.11c4.69-1.56,8.14-5.25,10.61-9.27a16.05,16.05,0,0,0-14.89,3.84,19.69,19.69,0,0,0-4.08,5.54",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M262.85,484.79a48.39,48.39,0,0,1,16,2.06,21,21,0,0,1-13.3,1.51,18.45,18.45,0,0,1-7.68-3.74,16.83,16.83,0,0,1,8.25-3.52c4.44-.54,8.9,1.06,12.69,4.11a53.09,53.09,0,0,0-15.93-.42",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M246.6,517.37a35.6,35.6,0,0,1,15.31-4.53c-2.87,4.33-6.75,7.35-11.29,8a15,15,0,0,1-8.61-1.47,16.54,16.54,0,0,1,6-8c3.82-2.51,8.55-2.43,13.22-.55a39.58,39.58,0,0,0-14.59,6.51",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M236.87,485.21a18.71,18.71,0,0,0-6.94,2.53,15,15,0,0,0,7.58,3.23,20.81,20.81,0,0,0,10.71-1.59,12.69,12.69,0,0,0-11.35-4.17",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M189.85,402.16c3.34,3.58,8.15,7.45,12.9,9.23-.41-6.68-4-12.62-10-13.36a27.38,27.38,0,0,0-6.83.52c.27,4.06,1.34,8.27,3.33,10.92,2.94,3.89,7.7,5,12.54,4-4-2.62-9.13-7.16-11.91-11.36",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M193.33,455.72a53.9,53.9,0,0,0,20.29-.47,26.5,26.5,0,0,0-17.41-5.55A19.59,19.59,0,0,0,185,454.31,19.89,19.89,0,0,0,197.67,462c5.63.86,11.4-1.05,16-4.4a57.1,57.1,0,0,1-20.3-1.86",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M199.31,476.19c5.79,4.46,12.26,5.58,17.75,3.41a20.14,20.14,0,0,0,8.08-6.2,20.65,20.65,0,0,0-9.3-2.67c-5.85-.2-11.41,2.17-16.53,5.46",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M208.28,410.05c-2,7.25-.38,13.49,3.73,17a18,18,0,0,0,8.52,3.75,22.08,22.08,0,0,0-1.44-9c-2-5.07-6.06-8.83-10.81-11.74",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M210.44,493.88a22.37,22.37,0,0,0-3.36,5c2.89-.26,5.39-.13,7.78-1.07s4.66-3,7.27-7.31c-4.13-1.67-8.62,0-11.69,3.34",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M187.63,437.2a13.9,13.9,0,0,0,7,4.2c4.38.91,8.41-1,11.63-4-4-4.71-9.45-5.81-13.71-3.95a15.22,15.22,0,0,0-5,3.76",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M219.27,441.29a48.58,48.58,0,0,1,16.28,6.43c-4.78.71-10,.6-14.53-1.61a18,18,0,0,1-7-6.21,15.73,15.73,0,0,1,9.82-1.78c4.83.78,8.85,4,12.08,8a48,48,0,0,0-16.62-4.84",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M193.39,379.1c2.79,4.2,5.94,7.84,10.09,10.19-.16-5-1.94-9.08-5.32-11.45a13.88,13.88,0,0,0-7.55-2.29,16,16,0,0,0,1.15,9c1.84,3.72,5.5,5.8,10.16,6.14a36.44,36.44,0,0,1-8.53-11.6",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M188.28,419.32a21,21,0,0,0-7.17,3.39,13.31,13.31,0,0,0,7.63,3.11,20,20,0,0,0,11-2.75,11,11,0,0,0-11.49-3.75",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M223.36,390c4.79,4.68,11.21,10.4,17.07,14.13-1-7.55-6-15.57-13.85-17.88a36.41,36.41,0,0,0-8.9-1.05,26,26,0,0,0,5.92,12.24,28.06,28.06,0,0,0,7.46,5.73,25.71,25.71,0,0,0,4.13,1.83,21.69,21.69,0,0,0,4.25,1.07c-5-4.4-11.92-10.88-16.08-16.07",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M284.48,318.78c-.61,4.81-.63,11,.72,15.83,4.32-4.25,6.41-10.79,3.63-16a30.12,30.12,0,0,0-4.05-5.15c-2.59,2.64-4.82,5.91-5.52,9.07-1.06,4.6.7,9.16,4,12.51a53,53,0,0,1,1.26-16.27",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M259.18,320.33a66,66,0,0,0,.69,20.29,32.62,32.62,0,0,0,4.43-17.39,21.16,21.16,0,0,0-4-11.23,18.91,18.91,0,0,0-6.22,12.65c-.44,5.64,1.39,11.33,4,16a64.76,64.76,0,0,1,1.07-20.28",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M247.44,396.88a17,17,0,0,0-.42,16.76,25.67,25.67,0,0,0,6.57,7.73,19,19,0,0,0,.7-8.6c-.8-5.45-3.46-10.85-6.85-15.89",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M297.16,330c-6.2,2.89-9.51,7.9-9.66,13.3a20.14,20.14,0,0,0,2.09,9,20.53,20.53,0,0,0,5.33-6.61c2.36-4.73,2.82-10.19,2.24-15.73",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M219,361a31.45,31.45,0,0,0-9.26-2c2.33,4.09,3.88,7.8,6.84,10.72s7.27,5.05,14.76,6.63c-.59-6.88-5.7-12.7-12.34-15.34",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M247.93,346.67a12.58,12.58,0,0,0-2.39,7.43c.14,4.36,2.8,7.93,6.09,10.69a12.68,12.68,0,0,0,.6-13.76,15.24,15.24,0,0,0-4.3-4.36",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M274.26,360a8.61,8.61,0,0,0-4.16,3.34c-1.56,2.53-1.39,5.57-.56,8.38a8.64,8.64,0,0,0,5.53-7.61,10.46,10.46,0,0,0-.81-4.11",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M231.92,326.58a11.68,11.68,0,0,0,.63,8.55c2.27,4.34,7.11,6.85,12.37,8.38,2.46-6.13.27-11.86-5-14.68a22.13,22.13,0,0,0-8-2.25",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M239.32,367.55a52,52,0,0,1,11.11,17.3c-5.72-2.64-10.77-6.5-13.47-11.74a18.22,18.22,0,0,1-1.8-10.58,21.63,21.63,0,0,1,11.45,5.32c4.23,4,5.74,9.8,5.59,15.77a54.24,54.24,0,0,0-12.88-16.07",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M217.56,339.78c4.24,3.65,7.79,7.68,9.91,12.53-5.16-1-9.33-3.55-11.61-7.55a15.44,15.44,0,0,1-1.85-8.52,17.69,17.69,0,0,1,9.65,2.56c3.84,2.57,5.48,7,5.39,12.08a40.2,40.2,0,0,0-11.49-11.1",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M280,343.5a20.22,20.22,0,0,0-1.57-7.25,15,15,0,0,0-4.26,7.07,20.13,20.13,0,0,0,.24,10.91A12.43,12.43,0,0,0,280,343.5",
    transform: "translate(-148 -302.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M307.12,309.35c-1.62,5.69-3.19,13.17-3,19.54,6.34-3.6,10.12-11,7.92-18.33a44.28,44.28,0,0,0-3.6-7.67c-3.31,2.42-6.47,5.67-8,9.23-2.27,5.22-1.61,11.32,1.24,16.6a89.37,89.37,0,0,1,5.44-19.37",
    transform: "translate(-148 -302.89)"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(7.51 135.03) rotate(77.99)"
  }, "I")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(11.13 149.92) rotate(71.21)"
  }, "N")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "matrix(0.44, 0.9, -0.9, 0.44, 19.07, 170.74)"
  }, "T")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "matrix(0.55, 0.83, -0.83, 0.55, 28.21, 187.78)"
  }, "E")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "matrix(0.65, 0.76, -0.76, 0.65, 39.95, 204.36)"
  }, "R")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(54.36 219.94) rotate(41.33)"
  }, "N")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(71.64 234.09) rotate(33.4)"
  }, "A")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(89.48 244.99) rotate(26.17)"
  }, "T")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "matrix(0.94, 0.34, -0.34, 0.94, 107.04, 252.84)"
  }, "I")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "cls-13",
    transform: "translate(121.62 257.66) rotate(13.11)"
  }, "O")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "cls-14",
    transform: "translate(143.98 262.07) rotate(5.07)"
  }, "N")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "cls-15",
    transform: "translate(166.26 263.26) rotate(-2.85)"
  }, "A")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "cls-16",
    transform: "translate(187.61 261.42) rotate(-10.26)"
  }, "L")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    className: "cls-17",
    transform: "translate(206.34 257.32) rotate(-16.39)"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    className: "cls-18",
    transform: "matrix(0.92, -0.38, 0.38, 0.92, 220.3, 252.74)"
  }, "F")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    className: "cls-19",
    transform: "matrix(0.87, -0.5, 0.5, 0.87, 238.35, 244.51)"
  }, "R")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    className: "cls-20",
    transform: "matrix(0.79, -0.61, 0.61, 0.79, 256.37, 233.31)"
  }, "U")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    className: "cls-21",
    transform: "matrix(0.71, -0.7, 0.7, 0.71, 273.18, 219.27)"
  }, "I")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    className: "cls-22",
    transform: "matrix(0.63, -0.77, 0.77, 0.63, 283.76, 208.24)"
  }, "T")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    className: "cls-22",
    transform: "matrix(0.55, -0.84, 0.84, 0.55, 295.4, 192.96)"
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "matrix(0.45, -0.89, 0.89, 0.45, 303.13, 180.4)"
  }, "H")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    className: "cls-24",
    transform: "matrix(0.32, -0.95, 0.95, 0.32, 312.39, 160.09)"
  }, "U")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    className: "cls-25",
    transform: "matrix(0.19, -0.98, 0.98, 0.19, 318.65, 138.97)"
  }, "B")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a824e6ae3a3980aac3366f68f00a081d.svg";
export { ForwardRef as ReactComponent };